import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'sticky',
    width: '100vw',
    alignItems: 'center',
    justifyContent: 'space-between',
    top: 0,
    zIndex: 3,
    borderBottom: `1px solid ${theme.palette.grey[700]}`,
    backgroundColor: theme.palette.grey[900],
  },

  tagFilters: {
    overflowX: 'auto',
    whiteSpace: 'nowrap',
  },

  selectedTag: {
    margin: theme.spacing(1),
  },
}));

export default useStyles;
